/* unplugin-vue-components disabled */import { render } from "./E808B2Triangle.vue?vue&type=template&id=616bdd52&scoped=true"
import script from "./E808B2Triangle.vue?vue&type=script&lang=js"
export * from "./E808B2Triangle.vue?vue&type=script&lang=js"

import "./E808B2Triangle.vue?vue&type=style&index=0&id=616bdd52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616bdd52"]])

export default __exports__